export default __webpack_public_path__ + "static/media/bitforex_logo.95a15435.svg";